export function isAssistantEnabled(): boolean {
  return import.meta.env.VITE_ASSISTANT_ENABLED === 'true';
}

export function assistantUrl(): string {
  return import.meta.env.VITE_ASSISTANT_URL || 'http://127.0.0.1:8200/';
}
